module.exports = __webpack_public_path__ + "static/media/Kimberly_Mackey_avatar.83c92ace.jpg";